export default __webpack_public_path__ + "static/media/qs-icon.ee95e9b5.svg";